import { WeightUnit } from "@redotech/crdb-enums/product/weight-unit";
import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { WeightFormat } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";
import { splitWeight } from "@redotech/redo-fulfillment-outbound-labels-common/util";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

const catalogEntry = fgColumnEntries.weight;

function formatDisplayWeightGrams(
  displayWeightGrams: number,
  weightFormat: WeightFormat,
): string {
  if (weightFormat === WeightFormat.METRIC) {
    const [kg, g] = splitWeight(
      { unit: WeightUnit.G, value: displayWeightGrams },
      [WeightUnit.Kg, WeightUnit.G],
    );

    const metricParts = [];
    if (kg) {
      metricParts.push(`${kg} kg`);
    }

    if (g) {
      metricParts.push(`${g} g`);
    }

    return metricParts.length > 0 ? metricParts.join(", ") : "0 g";
  } else {
    const [lbs, oz] = splitWeight(
      { unit: WeightUnit.G, value: displayWeightGrams },
      [WeightUnit.Lb, WeightUnit.Oz],
    );

    const imperialParts = [];
    if (lbs === 1) {
      imperialParts.push(`${lbs} lb`);
    } else if (lbs > 1) {
      imperialParts.push(`${lbs} lbs`);
    }

    if (oz) {
      imperialParts.push(`${oz} oz`);
    }

    return imperialParts.length > 0 ? imperialParts.join(", ") : "0 oz";
  }
}

export function OrderWeightColumn(
  weightFormat: WeightFormat,
): Column2<FulfillmentGroupData> {
  return {
    key: catalogEntry.key,
    title: catalogEntry.title,
    alignment: ColumnAlignment.LEFT,
    width: catalogEntry.defaultWidth,
    renderNormalCell: ({ row }) => (
      <RedoTableTextCell
        text={formatDisplayWeightGrams(
          row.displayWeightGrams ?? 0,
          weightFormat,
        )}
      />
    ),
    sort: catalogEntry.sortDirection,
  };
}
